import { createFileRoute } from '@tanstack/react-router';
import { GenealogyReport } from '../../../features/reports/screens/GenealogyReport';

export interface GenealogyReportSearch {
  dispatchId?: string;
}

/** Owned by G25. Report #12 (BUILD_SPEC.md §9.7) — a lookup form by dispatch.
 * Accepts an optional `?dispatchId=` deep link (e.g. from a future dispatch
 * detail "view genealogy" action). */
export const Route = createFileRoute('/_authenticated/reports/genealogy')({
  validateSearch: (search: Record<string, unknown>): GenealogyReportSearch => ({
    dispatchId: typeof search.dispatchId === 'string' ? search.dispatchId : undefined,
  }),
  component: GenealogyReportRoute,
});

function GenealogyReportRoute() {
  const { dispatchId } = Route.useSearch();
  return <GenealogyReport initialDispatchId={dispatchId} />;
}
